// Cobrar con el datáfono de recepción y el QR de pago.
export const datafono = {
  card: {
    name: "POS",
    description: "Incassa con il POS della reception dalla prenotazione",
    count: "{count} POS | {count} POS",
  },
  settings: {
    title: "POS della reception",
    lead: "Incassa con il POS dalla prenotazione: l'importo appare sul dispositivo, l'ospite paga con la carta e la prenotazione viene segnata come pagata automaticamente.",
    listTitle: "I tuoi POS",
    add: "Aggiungi POS",
    loading: "Caricamento…",
    empty: "Non hai ancora nessun POS collegato.",
    simulatorTag: "Simulatore",
    online: "Online",
    offlineSince: "Offline · ultimo segnale {when}",
    neverConnected: "Non ancora collegato",
    bridgeVersion: "ponte {version}",
    token: "token",
    newToken: "Nuovo token",
    remove: "Rimuovi",
    howTitle: "Come collegarlo",
    how1: "Aggiungi qui il POS e copia il suo token (viene mostrato una sola volta).",
    how2: "Sul computer della reception a cui è collegato il POS, avvia il ponte di WACheckin con quel token.",
    how3: "Quando qui appare «Online», puoi incassare da qualsiasi prenotazione: Aggiungi pagamento → Carta / POS.",
    bankNote: "Con Redsys devi attivare con la tua banca il «TPV-PC» (modalità Implantado) e un POS certificato. Un POS autonomo WiFi o 4G non si può collegare.",
    addTitle: "Aggiungi POS",
    nameLabel: "Nome",
    namePlaceholder: "Per esempio: Reception",
    typeLabel: "Tipo",
    typeReal: "POS Redsys (TPV-PC)",
    typeRealHint: "Il POS della tua banca, collegato al computer della reception.",
    typeSim: "Simulatore",
    typeSimHint: "Per provare senza dispositivo. Non muove denaro.",
    cancel: "Annulla",
    saving: "Salvataggio…",
    create: "Aggiungi",
    saveError: "Impossibile salvare. Riprova.",
    loadError: "Impossibile caricare i POS.",
    tokenTitle: "Token del POS",
    tokenLead: "Inserisci questi due dati nel ponte del computer della reception.",
    apiLabel: "Server",
    tokenLabel: "Token",
    copy: "Copia",
    copied: "Copiato",
    tokenOnce: "Salvalo ora: non verrà mostrato di nuovo. Se lo perdi, generane uno nuovo e il precedente smetterà di valere.",
    done: "Fatto",
    newTokenConfirm: "Generare un nuovo token per «{name}»? Quello attuale smetterà di valere e andrà inserito di nuovo nel ponte.",
    removeConfirm: "Rimuovere il POS «{name}»? Non gli si potranno più inviare incassi.",
    removed: "POS rimosso.",
  },
  add: {
    sendTitle: "Incassa sul POS",
    sendHint: "L'importo appare sul dispositivo e la prenotazione viene segnata come pagata automaticamente al passaggio della carta.",
    online: "online",
    offline: "offline",
    noneOnline: "Nessun POS è online. Verifica che il computer della reception sia acceso e il ponte aperto.",
    manualTitle: "Già incassato, solo registrarlo",
    manualHint: "Viene registrato come pagato senza passare dal POS.",
    submit: "Incassa sul POS",
  },
  line: {
    pendiente: "Invio al POS",
    enviado: "Sul POS",
    sin_respuesta: "Nessuna risposta · verificare",
  },
  cobro: {
    terminal: "POS",
    cancel: "Annulla incasso",
    hide: "Continua in background",
    notCharged: "Non incassato",
    wasCharged: "Sì, incassato",
    retry: "Riprova",
    close: "Chiudi",
    authCode: "Autorizzazione {code}",
    genericError: "Impossibile completare. Riprova.",
    title: {
      pendiente: "Invio al POS…",
      enviado: "Chiedi la carta",
      cobrado: "Incassato",
      rechazado: "Carta rifiutata",
      cancelado: "Incasso annullato",
      error: "Il POS ha dato un errore",
      caducado: "Il POS non ha risposto",
      sin_respuesta: "È stato incassato?",
    },
    text: {
      pendiente: "L'importo apparirà sul POS tra pochi secondi.",
      enviado: "L'importo è sul POS. Appena pagato, la prenotazione viene segnata automaticamente.",
      cobrado: "Questo pagamento è registrato nella prenotazione.",
      rechazado: "Non è stato incassato nulla.",
      cancelado: "Non è stato incassato nulla.",
      error: "Non è stato incassato nulla.",
      caducado: "Non è stato incassato nulla.",
      sin_respuesta: "Il POS non ha restituito il risultato. Controlla il dispositivo o lo scontrino prima di incassare di nuovo.",
    },
  },
  qr: {
    button: "Mostra QR",
    title: "Scansiona per pagare",
    text: "L'ospite lo scansiona con il telefono e paga sulla pagina sicura del gateway. La prenotazione viene segnata come pagata automaticamente.",
    copy: "Copia link",
    copied: "Link copiato",
    close: "Chiudi",
  },
};
